import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '@fastnorth/kraken/components/card';
import { Paragraph, Text } from '@fastnorth/kraken/components/typography';
import { NavLink } from '@fastnorth/kraken/components/navigation';
import { Link } from 'react-router-dom';
import { Div, Flex } from '@fastnorth/kraken/components/layout';
import { useCountdown } from 'src/hooks/useCountdown';

export const RaceListItem = (props: RaceListItemProps): ReactElement => {
  const { title, href, disabled, startTime } = props;
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.event.race_list' });
  const countdown = useCountdown(startTime);

  return (
    <Div className={'min-w-[280px] max-w-[310px] group'}>
      {!disabled && href && (
        <Card header={{ title: title }} height={'full'} shadow={'md'}>
          <Flex className={`h-full ${countdown ? 'flex-col' : ''}`}>
            {startTime && countdown && (
              <Text size="sm" spacing={'0 0 4'}>
                {t('race_starts_in', {
                  days: countdown.days,
                  hours: countdown.hours,
                  minutes: countdown.minutes,
                })}
              </Text>
            )}

            <Flex className={'w-full items-end'}>
              <NavLink
                id={'race-list-item-link'}
                variant={'pill'}
                accent={'primary'}
                width={'full'}>
                <Link to={href}>{t('view_results_label')}</Link>
              </NavLink>
            </Flex>
          </Flex>
        </Card>
      )}
      {disabled && (
        <Card header={{ title: title }} height={'full'} spacing={'0 0 4'}>
          {startTime && countdown && (
            <Text size="sm" spacing={'0 0 4'}>
              {t('race_starts_in', {
                days: countdown.days,
                hours: countdown.hours,
                minutes: countdown.minutes,
              })}
            </Text>
          )}
          <Paragraph align={'center'} type={'helper'}>
            {t('no_available_results_label')}
          </Paragraph>
        </Card>
      )}
    </Div>
  );
};

type RaceListItemProps = {
  title: string;
  href?: string;
  disabled: boolean;
  startTime?: string;
};

export default RaceListItem;
